import { I18n } from 'react-redux-i18n';
import { getDropdown } from "../utils/dropdownLists";

const interfaceSearchFields = (searchFieldValues, categoryList, unitTypeList, entityList) => {
    return {
        rows: [
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "interfaceIdentifier",
                        label: I18n.t("interfaces.list.interfaceId"),
                        type: "text",
                        value: searchFieldValues.interfaceIdentifier.value,
                    },
                    {
                        id: "name",
                        label: I18n.t("interfaces.list.name"),
                        type: "text",
                        value: searchFieldValues.name.value,
                    }
                ]
            },
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "dataType",
                        label: I18n.t("interfaces.list.dataType"),
                        type: "dropdown",
                        value: searchFieldValues.dataType.value,
                        data: getDropdown("dataType"),
                        validator: () => { }
                    },
                    {
                        id: "category",
                        label: I18n.t("interfaces.list.category"),
                        type: "dropdown",
                        value: searchFieldValues.category.value,
                        data: categoryList,
                        validator: () => { }
                    },
                    {
                        id: "historyConfiguration",
                        label: I18n.t("interfaces.list.historyConfiguration"),
                        type: "dropdown",
                        value: searchFieldValues.historyConfiguration.value,
                        data: getDropdown("historyConfiguration"),
                        validator: () => { }
                    }
                ]
            },
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "unitType",
                        label: I18n.t("interfaces.list.unitType"),
                        type: "dropdown",
                        value: searchFieldValues.unitType.value,
                        data: unitTypeList,
                        validator: () => { }
                    },
                    {
                        id: "entityId",
                        label: I18n.t("interfaces.list.entityId"),
                        type: "dropdown",
                        value: searchFieldValues.entityId.value,
                        data: entityList,
                        validator: () => { }
                    }
                ]
            },
        ]
    }
};

export {
    interfaceSearchFields
}